// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAtHVpbZZIDIAyRwWCkedifLTLfZCz_JBU",
  authDomain: "osrstracking-1fc4c.firebaseapp.com",
  projectId: "osrstracking-1fc4c",
  storageBucket: "osrstracking-1fc4c.firebasestorage.app",
  messagingSenderId: "6095695273",
  appId: "1:6095695273:web:9c80b62227b445255da8b8",
  measurementId: "G-6NF2T2T3E1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);


const auth = getAuth(app);

export { app, auth, analytics };